import { render, staticRenderFns } from "./burn.vue?vue&type=template&id=46eb5e9a&scoped=true"
import script from "./burn.vue?vue&type=script&lang=js"
export * from "./burn.vue?vue&type=script&lang=js"
import style0 from "./burn.vue?vue&type=style&index=0&id=46eb5e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eb5e9a",
  null
  
)

export default component.exports